<template>
  <div>
    <v-alert colored-border dense border="left" color="blue" class="bg-info mb-2 body-2 mt-5">
      <v-row no-gutters align="center">
        <v-col class="grow">Ubah / Lengkapi {{ title }}</v-col>
        <v-col class="shrink">
          <v-btn right depressed small color="info" dark @click="onEdit">
            <v-icon small>mdi-pencil</v-icon> Ubah
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <v-row>
      <template v-for="(sch, id) in schema">
        <v-col cols="12" sm="12" md="12" :lg="sch.size" :key="id">
          <h3 v-if="sch.title" class="indigo--text">{{ sch.title }}</h3>
          <v-row>
            <template v-for="(item, idItem) in sch.items">
              <v-col v-if="!item.hidden" cols="12" sm="12" md="12" :lg="item.size || 4" :key="idItem">
                <div class="grey--text">
                  <span class="subtitle-2 font-weight-regular">{{ item.label }}</span>
                </div>
                <template>
                  <span
                    v-if="item.value"
                    :class="['subtitle-1', item.update ? 'orange--text' : 'black--text']"
                    v-html="item.value"
                  />
                  <span v-else class="red--text">Belum dilengkapi</span>
                </template>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'View',
  props: {
    title: {
      type: String,
      default: 'Bidata FSP',
    },
    schema: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onEdit() {
      this.$emit('edit');
    },
  },
};
</script>

<style scoped></style>
